import get from 'lodash/get'

export function canBuildOWCalendarRequest(tripDetails, displayMonths) {
  const { flights } = tripDetails

  if (!displayMonths) {
    return false
  }

  const { displayedFromMonth, displayedToMonth } = displayMonths

  return !(
    !get(flights, '[0].arrivalAirport') ||
    !get(flights, '[0].departureAirport') ||
    !displayedFromMonth ||
    !displayedToMonth
  )
}

export function canBuildRTCalendarRequest(tripDetails, displayMonths, departDate) {
  if (!canBuildOWCalendarRequest(tripDetails, displayMonths)) return false

  const { flights } = tripDetails
  const departureDate = departDate || flights[0].departureDate

  return !!departureDate
}
